import create from 'zustand';
import createStoreSelectors from '@stores/utils/createStoreSelector';
import { emptyObject } from '@constants/empty';

const useStore = create((set) => ({
  quizInfo: {},
  quizUID: null,
  sessionUID: null,
  classPreference: {},
  attemptsInfo: {},
  setInitialDSTInfo: ({ quizInfo, classPreference, attemptsInfo }) => {
    set((state) => ({
      ...state,
      quizInfo,
      classPreference,
      attemptsInfo
    }));
  },
  setQuizUID: (quizUID) => {
    set((state) => ({
      ...state,
      quizUID
    }));
  },
  setSessionUID: (sessionUID) => {
    set((state) => ({
      ...state,
      sessionUID
    }));
  }
}));

const useDSTMetaInfo = createStoreSelectors(useStore);

const useDSTMetaInfoStore = () => {
  return {
    quizInfo: useDSTMetaInfo.use.quizInfo() || emptyObject,
    classPreference: useDSTMetaInfo.use.classPreference() || emptyObject,
    attemptsInfo: useDSTMetaInfo.use.attemptsInfo() || emptyObject,
    quizUID: useDSTMetaInfo.use.quizUID(),
    sessionUID: useDSTMetaInfo.use.sessionUID(),
    setQuizUID: useDSTMetaInfo.use.setQuizUID(),
    setSessionUID: useDSTMetaInfo.use.setSessionUID(),
    setInitialDSTInfo: useDSTMetaInfo.use.setInitialDSTInfo()
  };
};

export { useDSTMetaInfoStore, useDSTMetaInfo };
